import type { PcapPeriodResult } from './types';

export default function getPeriodLabel(period: PcapPeriodResult) {
  const start = period.periodStart.toLabel('--', 'MMM d');
  const end = period.periodEnd.toLabel('--', 'MMM d');
  return `(${start} – ${end})`;
}
